import { memo, useState } from "react";

import classnames from "classnames";
import { Select } from "neetoui";
import { useTranslation } from "react-i18next";

import { COUNTRY_PICKER_OPTIONS, COUNTRY_PICKER_STYLES } from "./constants";
import SingleValue from "./SingleValue";

const CountryPicker = ({ countryCode, onChange, ...otherProps }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const { t } = useTranslation();

  return (
    <div
      className={classnames("flex-shrink-0", {
        "w-10": !searchTerm,
        "w-24": searchTerm,
      })}
    >
      <Select
        isSearchable
        aria-label={t("neetoMolecules.phoneNumberInput.countryCodeAriaLabel")}
        data-testid="phonenumber-country-picker"
        options={COUNTRY_PICKER_OPTIONS}
        strategy="fixed"
        styles={COUNTRY_PICKER_STYLES}
        value={{ value: countryCode }}
        components={{
          SingleValue: () => <SingleValue {...{ countryCode }} showEmoji />,
        }}
        isOptionSelected={({ value }, [selectedOption]) =>
          selectedOption?.name === value
        }
        onChange={option => onChange(option.value)}
        onInputChange={setSearchTerm}
        {...otherProps}
      />
    </div>
  );
};

export default memo(CountryPicker);
